export const environment = {
    envName: "dev",
    production: false,
    ApiEndpoint: 'https://cpd-api-dev-dbdrddceejgva5he.z01.azurefd.net',
    AssetBlobApiEndpoint: 'https://stcpddev.blob.core.windows.net',
    SessionTimeout: "900000",
    SessionDialogTimeout: "300000",
    EnableReset: "enabled",
    EnableLearningResources: "enabled",
    MSALClientID: "57eca463-fc55-437f-8ffa-e1cccb12ea27",
    MSALAuthority: 'https://lsaexternaldev.ciamlogin.com/',
    MSALRedirectUri: 'https://dev.cpd.lawsociety.ab.ca',
    MSALApi: 'api://lsa-cpd-api-dev/.default',
    PortalURL:''

  };